"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var DropdownSelect = /** @class */ (function (_super) {
    __extends(DropdownSelect, _super);
    function DropdownSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: false };
        _this.preventAutoClose = false;
        _this.onWindowClickCapture = function () { return (_this.preventAutoClose = false); };
        _this.onWindowClick = function () { return !_this.preventAutoClose && _this.closeItems(); };
        _this.openItems = function () {
            _this.preventAutoClose = true;
            _this.setState({ open: true });
        };
        _this.closeItems = function () {
            _this.preventAutoClose = false;
            _this.setState({ open: false });
        };
        _this.isItemSelected = function (id) {
            if (_this.props.multiSelect) {
                return _this.props.value.includes(id);
            }
            else {
                return id === _this.props.value;
            }
        };
        _this.selectItem = function (id) {
            if (_this.props.multiSelect) {
                var value = _this.props.value;
                var newValue = void 0;
                if (!value.includes(id))
                    newValue = value.concat([id]);
                else
                    newValue = value.slice().filter(function (item) { return item !== id; });
                _this.props.onChange(newValue);
                if (newValue.length === 0)
                    _this.closeItems();
            }
            else {
                _this.props.onChange(id);
                _this.closeItems();
            }
        };
        _this.getEverySelectedLabel = function () {
            return _this.props.placeholder ? "\uBAA8\uB4E0 " + _this.props.placeholder : "\uBAA8\uB450 \uC120\uD0DD\uB428";
        };
        _this.getSelectedInfo = function () {
            var _a = _this.props, placeholder = _a.placeholder, _b = _a.isFilter, isFilter = _b === void 0 ? false : _b, items = _a.items;
            var selected;
            var hasCheckSign;
            var label;
            if (_this.props.multiSelect) {
                var value = intersection(_this.props.value, items.map(function (_a) {
                    var id = _a.id;
                    return id;
                }));
                var length_1 = value.length;
                hasCheckSign = !!length_1;
                selected = isFilter || hasCheckSign;
                switch (length_1) {
                    case 0:
                        label = placeholder || '선택해주세요';
                        break;
                    case 1: {
                        var selectedId_1 = value[0];
                        var selectedItem = items.find(function (_a) {
                            var id = _a.id;
                            return id === selectedId_1;
                        });
                        label = selectedItem.name;
                        break;
                    }
                    default:
                        if (length_1 === items.length) {
                            label = _this.getEverySelectedLabel();
                        }
                        else {
                            label = placeholder ? length_1 + " " + placeholder : length_1 + "\uAC1C \uC120\uD0DD\uB428";
                        }
                        break;
                }
            }
            else {
                var value_1 = _this.props.value;
                var selectedItem = items.find(function (_a) {
                    var id = _a.id;
                    return id === value_1;
                });
                selected = selectedItem != null;
                hasCheckSign = selected;
                if (selected) {
                    label = selectedItem.name;
                }
                else {
                    label = placeholder || '선택해주세요';
                }
            }
            return [selected, hasCheckSign, label || '\u00a0'];
        };
        return _this;
    }
    DropdownSelect.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('popstate', this.closeItems);
        window.addEventListener('click', this.onWindowClickCapture, true);
        if (this.props.openOnMount) {
            window.setTimeout(function () {
                _this.setState({ open: true });
            }, 1);
        }
    };
    DropdownSelect.prototype.componentWillUnmount = function () {
        window.removeEventListener('popstate', this.closeItems);
        window.removeEventListener('click', this.onWindowClickCapture, true);
        window.removeEventListener('click', this.onWindowClick, false);
    };
    DropdownSelect.prototype.componentDidUpdate = function (_prevProps, prevState) {
        var open = this.state.open;
        if (prevState.open === open)
            return;
        var _a = this.props, onOpen = _a.onOpen, onClose = _a.onClose;
        if (open) {
            onOpen && onOpen();
            window.addEventListener('click', this.onWindowClick, false);
        }
        else {
            onClose && onClose();
            window.removeEventListener('click', this.onWindowClick, false);
        }
    };
    DropdownSelect.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, className = _b.className, style = _b.style, error = _b.error, items = _b.items;
        var open = this.state.open;
        var _c = this.getSelectedInfo(), selected = _c[0], hasCheckSign = _c[1], label = _c[2];
        return (React.createElement("div", { className: classnames_1.default(styles.dropdownSelect, (_a = {},
                _a[styles.selected] = selected,
                _a[styles.hasCheckSign] = hasCheckSign,
                _a[styles.error] = error && !selected,
                _a[styles.open] = open,
                _a[styles.touch] = 'ontouchstart' in window,
                _a), className), style: style, onClickCapture: open ? this.closeItems : this.openItems },
            React.createElement("div", { className: styles.label }, label),
            React.createElement(icons_1.DropdownIcon, { className: styles.dropdownIcon }),
            React.createElement("div", { className: styles.items, onClickCapture: this.openItems },
                React.createElement("ul", { role: "listbox" }, items.map(function (item) {
                    var itemSelected = _this.isItemSelected(item.id);
                    return (React.createElement("li", { key: item.id || '', className: itemSelected ? styles.itemSelected : undefined, onClick: function () { return _this.selectItem(item.id); } },
                        React.createElement(icons_1.DropdownSelectedIcon, { className: styles.selectedIcon }),
                        item.name));
                })))));
    };
    return DropdownSelect;
}(React.Component));
exports.default = DropdownSelect;
function intersection(a, b) {
    return a.filter(function (item) { return new Set(b).has(item); });
}
